export default "__VITE_ASSET__DclFwfHN__"